






import { Vue, Component, Prop, Emit, Watch } from 'nuxt-property-decorator';
import MarkdownEditor from '../../side-panel/notes/MarkdownEditor.vue';

@Component({
  components: { MarkdownEditor }
})
export default class ReadMore extends Vue {
  @Prop({ type: Boolean, default: false })
  setLimit!: boolean;

  @Prop({ type: String, required: true })
  text!: string;

  expanded: boolean = false;
  localText: string = '';
  limit: number = 78;

  get isTruncated(): boolean {
    return this.localText.length >= this.limit;
  }

  @Watch('text')
  onTextChange(newText: string) {
    this.localText = newText;
  }

  @Emit('expanded-changed')
  setExpandedState(val: boolean): boolean {
    return val;
  }

  created() {
    this.localText = this.text;
  }

  mounted() {
    this.$nextTick(() => this.$emit('readmore-content-updated'));
  }

  updated() {
    this.$nextTick(() => this.$emit('readmore-content-updated'));
  }
}
